export const FeatureRewriteApiPath = {
  LIST_FEATURE_PAGES_WITH_METRICS: '/api/sites/{site_id}/feature-rewrite/pages' // GET List Feature Pages With Metrics
}

export type FeatureRewriteApiPath =
  (typeof FeatureRewriteApiPath)[keyof typeof FeatureRewriteApiPath]

// publish はAPIにより '1' / 1 / true / 'PUBLISH' 等の揺れがある
export type PublishValue = string | number | boolean | null

export interface ListFeaturePagesWithMetricsVars {
  site_id: number
}

export interface FeaturePageMetrics {
  views_30d: number
  avg_dwell_sec: number
}

export interface FeaturePage {
  page_id: number
  title?: string | null
  management_title?: string | null
  publish: PublishValue
  content_count?: number | null
  metrics?: FeaturePageMetrics | null
  // 後方互換のフラット指標（metrics が無い場合のフォールバック）
  access_count_30d?: number | null
  avg_stay_seconds?: number | null
}

export interface ListFeaturePagesWithMetricsResponse {
  pages: FeaturePage[]
  total: number
}
